import { render, staticRenderFns } from "./CommunicationSupporter.vue?vue&type=template&id=399d2a4a&scoped=true&"
import script from "./CommunicationSupporter.vue?vue&type=script&lang=js&"
export * from "./CommunicationSupporter.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationSupporter.vue?vue&type=style&index=0&id=399d2a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399d2a4a",
  null
  
)

export default component.exports